import React from 'react';
import TeamsDashboard from '../../components/features/teams/TeamsDashboard';

const Teams: React.FC = () => {
  return <TeamsDashboard />;
};

export default Teams;